import type React from 'react';

const FOCUSABLE = [
  'a[href]',
  'button:not([disabled])',
  'input:not([disabled]):not([type="hidden"])',
  'select:not([disabled])',
  'textarea:not([disabled])',
  '[tabindex]:not([tabindex="-1"])',
].join(',');

/** Elements inside `root` that Tab can reach, in document order. */
export const focusableWithin = (root: Element | null): HTMLElement[] =>
  root ? [...root.querySelectorAll<HTMLElement>(FOCUSABLE)] : [];

/** Wraps Tab and Shift+Tab around the ends of `root`, so focus can't leave it. */
export const trapTab = (event: KeyboardEvent | React.KeyboardEvent, root: Element | null): void => {
  const items = focusableWithin(root);
  if (items.length === 0) {
    event.preventDefault();
    return;
  }

  const first = items[0];
  const last = items[items.length - 1];
  const active = document.activeElement;

  if (event.shiftKey && (active === first || !root?.contains(active))) {
    event.preventDefault();
    last.focus();
  } else if (!event.shiftKey && (active === last || !root?.contains(active))) {
    event.preventDefault();
    first.focus();
  }
};
